import { render, staticRenderFns } from "./DocumentRequests.vue?vue&type=template&id=5b540a88&scoped=true&"
import script from "./DocumentRequests.vue?vue&type=script&lang=js&"
export * from "./DocumentRequests.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequests.vue?vue&type=style&index=0&id=5b540a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b540a88",
  null
  
)

export default component.exports